import { render, staticRenderFns } from "./importDetalRecord.vue?vue&type=template&id=4580a134&scoped=true&"
import script from "./importDetalRecord.vue?vue&type=script&lang=js&"
export * from "./importDetalRecord.vue?vue&type=script&lang=js&"
import style0 from "./importDetalRecord.vue?vue&type=style&index=0&id=4580a134&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580a134",
  null
  
)

export default component.exports